import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
  Box,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import * as Yup from 'yup';
import { SettingsPageRow } from '..';
import LandingPageInputSection from '../../LandingPage/LandingPageInputSection';
import { MessagingDescription } from './MessagingDescription';
import { FormBodyAPI } from '../../../constants/fieldsTypes';
import { BaseTextField, ResizableTextField } from '../../TextField';
import BaseTypography from '../../Text/BaseTypography';
import { IconPicker } from '../ExtensionsPage';
import { GraySmall } from '../../../theme/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    helperText: {
      color: GraySmall,
    },
    iconPickerWrapper: {
      marginTop: theme.spacing(3.5),
      marginBottom: theme.spacing(3.5),
    },
  }),
);

export const useMessagingSettingsForm = () => {
  const classes = useStyles();
  const validationScheme = Yup.object().shape({
    fields: Yup.object().shape({
      messageBody: Yup.string().required('Message is required'),
    }),
  });

  const getSubmitValues = async () => ({});

  const FormRenderer: React.FC<FormBodyAPI> = ({
    errors,
    handleChange,
    handleBlur,
    values,
    touched,
    setFieldValue,
  }) => (
    <>
      <BaseTextField
        autoFocus
        fullWidth
        label={
          <div className={classes.container}>
            <BaseTypography fontType="13Medium">Name</BaseTypography>
            <BaseTypography className={classes.helperText}>
              &nbsp;- How it should appear in the sidebar
            </BaseTypography>
          </div>
        }
        variant="outlined"
        sizeVariant="medium"
        name="label"
        value={values.label}
        onChange={handleChange}
        onBlur={handleBlur}
        error={Boolean(touched && touched.label && errors && errors.label)}
        helperText={touched && touched.label && errors && errors.label}
      />
      <div className={classes.iconPickerWrapper}>
        <BaseTypography fontType="13Medium">Sidebar icon</BaseTypography>
        <IconPicker
          icon={values.icon || 'dashboard'}
          onIconSelected={iconName => setFieldValue('icon', iconName)}
        />
      </div>
      <SettingsPageRow description={<MessagingDescription />}>
        <Grid container spacing={3} style={{ paddingBottom: 16 }}>
          <LandingPageInputSection sm={6} title="" titlePlaceholderPadding={0}>
            <Typography component="div">
              <Box fontWeight={500} fontSize={13}>
                Message content
              </Box>
            </Typography>
            <Typography component="div">
              <Box fontWeight={600} fontSize={13} mt={1} mb={0.5}>
                {`Hello {firstName},`}
              </Box>
            </Typography>
            <ResizableTextField
              helperText={errors.fields && errors.fields.messageBody}
              error={!!(errors.fields && errors.fields.messageBody)}
              fullWidth
              name="fields.messageBody"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.fields.messageBody}
              variant="outlined"
            />
          </LandingPageInputSection>
        </Grid>
      </SettingsPageRow>
    </>
  );

  return { validationScheme, getSubmitValues, FormRenderer };
};
